module.exports = __webpack_public_path__ + "media/src/Quiz/sandbox/exampleCover-d63f519fa8b04c2a1d085dba5d657b1a.jpg";